import { z } from 'zod'

export const corePriceSchema = z.object({
  price: z.number(),
  validFrom: z.string(),
  validTo: z.string().nullable(),
})

export const coreReservationSchema = z.object({
  kind: z.string(),
  startDate: z.string(),
  endDate: z.string().nullable(),
})

export const coreAvailableRangeSchema = z.object({
  startDate: z.string(),
  endDate: z.string().nullable(),
})

export const coreDayReservableAreaSchema = z.object({
  rentableHierarchyId: z.number(),
  realPropertyHierarchyId: z.number(),
  additionalDetails: z.string().nullable(),
  residentDetailsFi: z.string().nullable(),
  residentDetailsSv: z.string().nullable(),
  residentDetailsEn: z.string().nullable(),
  locationDetails: z.string().nullable(),
  buildingPartLocationDetails: z.string(),
  buildingPartAddress: z.object({
    streetName: z.string(),
    streetNumber: z.string(),
    city: z.string(),
  }),
  prices: z.array(corePriceSchema),
  reservations: z.array(coreReservationSchema),
  availableRanges: z.array(coreAvailableRangeSchema),
})

export const contractDayReservableAreasDataSchema = z.object({
  dayReservableAreas: z.array(coreDayReservableAreaSchema),
})

export type contractDayReservableAreasData = z.infer<
  typeof contractDayReservableAreasDataSchema
>
export type CoreDayReservableArea = z.infer<typeof coreDayReservableAreaSchema>
